/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { currentUserSelector, useAppStore } from 'stores/appStore';

// COMPONENT
function DisplayIfRolesIsPresent({ requiredRoles, children }) {
  const currentUser = useAppStore(currentUserSelector);
  const userRoles = currentUser != null ? currentUser.roles : [];

  return userRoles != null && requiredRoles.some((val) => userRoles.indexOf(val) !== -1) ? children : null;
}

DisplayIfRolesIsPresent.propTypes = {
  requiredRoles: PropTypes.array.isRequired,
};

export default DisplayIfRolesIsPresent;
